import { render, staticRenderFns } from "./SocksProxy.vue?vue&type=template&id=a6bd98fe&scoped=true"
import script from "./SocksProxy.vue?vue&type=script&lang=js"
export * from "./SocksProxy.vue?vue&type=script&lang=js"
import style0 from "./SocksProxy.vue?vue&type=style&index=0&id=a6bd98fe&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a6bd98fe",
  null
  
)

export default component.exports